.baseIcon {
  width: 1em;
  height: 1em;
  fill: currentcolor;
  overflow: hidden;
}
